import React from 'react'

export default ({ ...props }) => (
  <svg
    {...props}
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    viewBox='0 0 841.9 595.3'
  >
    <g>
      <path
        className='st0'
        d='M210,266.8c-12.1,0.1-24.9,2.8-39.7,8.6v7.2c15.1-6.2,27.7-9.1,39.7-9.1V266.8z M154.9,290.7
		c8.4,3.6,13.3,5.2,22.3,1.6c16.5-6.5,29.2-8.6,42-6.7v-6.8c-13.7-1.8-27.2,0.4-44.5,7.3c-7,2.8-10.1,1.5-17.2-1.6
		c-8.2-3.5-16.5-6.5-27.3-4.8v6.8C139.7,284.7,147,287.3,154.9,290.7z M179.6,296.5c-8.6,3.4-15.7,2.1-23.2,0.7
		c-7.2-1.3-14.6-2.7-23.2,0.4v7.2c7.8-3.7,14.4-2.5,22-1.1c9.7,1.8,17.3,2.6,26.8-1.1c18.3-7.2,28.7-7.4,38.9-5.2v-6.9
		C208.2,288.3,196.3,290,179.6,296.5z M143.5,318.3v6.8c17,2.5,24.2,7.2,50.6-2.4c1.9-0.7,3.6-1.3,5.3-1.9v-7
		c-2.4,0.7-4.9,1.6-7.6,2.5C167.3,325.3,162.1,320.9,143.5,318.3z M184.5,307c-6,2.4-11.7,3.5-17.4,3.5c-5.4-0.1-13.1-1.6-17.7-3.1
		v7c13.6,3.8,24.6,4.1,37.6-1.1c13.6-5.4,21.3-6.1,28.2-5v-6.8C207.5,300.4,198.9,301.3,184.5,307z M151.8,270
		c-5.5-1.5-10.6-2.3-15.8-2.2v6.7c5.1-0.1,10.2,0.7,15.8,2.5V270z'
      />
      <g>
        <path
          className='st0'
          d='M241.3,320.9v-45.5H260c4.9,0,8.7,1,11.3,3.1c2.6,2.1,3.9,5.1,3.9,9c0,2.3-0.6,4.3-1.7,6
			c-1.1,1.7-2.7,3-4.7,3.8c2.4,0.8,4.3,2.2,5.7,4.1c1.4,1.9,2.1,4.2,2.1,6.8c0,4-1.4,7.1-4.1,9.4s-6.5,3.4-11.3,3.4H241.3z
			 M250.2,293.9h8.9c2.4,0,4.2-0.5,5.4-1.4s1.8-2.3,1.8-4c0-1.7-0.6-3.1-1.8-4c-1.2-0.9-3-1.4-5.4-1.4h-8.9V293.9z M250.2,301.5
			v11.7h10.3c2.2,0,3.9-0.5,5.2-1.6s1.9-2.5,1.9-4.3c0-1.8-0.6-3.2-1.9-4.2s-3-1.6-5.2-1.6H250.2z'
        />
        <path
          className='st0'
          d='M310.4,287.6v33.3h-8.9v-3.4c-1.1,1.4-2.5,2.4-4,3.1c-1.5,0.7-3.2,1-5,1c-3.4,0-6.2-1.1-8.2-3.3
			c-2.1-2.2-3.1-5.1-3.1-8.7v-22.1h8.9v20.1c0,2,0.5,3.5,1.4,4.5c0.9,1,2.2,1.6,4,1.6s3.2-0.6,4.4-1.8s1.8-2.8,1.8-4.8v-19.6H310.4z
			'
        />
        <path
          className='st0'
          d='M320.5,319.9c-2.8-1.1-4.9-2.7-6.4-4.6l5.5-5.6c1.1,1.5,2.6,2.7,4.5,3.7c1.8,0.9,3.7,1.4,5.6,1.4
			c1.7,0,3.1-0.3,4.1-0.9c1-0.6,1.5-1.4,1.5-2.5c0-0.8-0.2-1.4-0.7-1.8c-0.5-0.4-1.3-0.8-2.5-1.1c-0.3-0.1-0.7-0.2-1.1-0.3
			c-0.4-0.1-1.6-0.3-3.6-0.7c-2.2-0.4-3.8-0.8-4.9-1.2c-1.1-0.4-2.1-0.9-2.9-1.4c-1.2-0.8-2.1-1.7-2.7-2.9c-0.6-1.2-0.9-2.5-0.9-4.2
			c0-3.2,1.3-5.8,3.8-7.8c2.5-2,5.8-3,9.8-3c2.8,0,5.5,0.5,8,1.6s4.4,2.5,5.8,4.2l-5.1,5.6c-1.1-1.4-2.4-2.5-4-3.3s-3.2-1.1-4.9-1.1
			c-1.4,0-2.5,0.3-3.4,0.8c-0.8,0.5-1.3,1.3-1.3,2.2c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.3,0.1,0.7,0.2,1.2,0.3
			c0.4,0.1,1.3,0.3,2.7,0.5c2.6,0.5,4.4,1,5.6,1.4c1.1,0.4,2.1,0.8,3,1.3c1.4,0.8,2.4,1.8,3.1,3s1,2.7,1,4.4c0,3.3-1.4,6.1-4.1,8.1
			c-2.7,2.1-6.2,3.1-10.4,3.1C326.4,321.6,323.3,321.1,320.5,319.9z'
        />
        <path className='st0' d='M348.8,283.7v-8.2h9.1v8.2H348.8z M357.8,287.6v33.3h-8.9v-33.3H357.8z' />
        <path
          className='st0'
          d='M364.8,320.9v-33.3h8.9v3.4c1.1-1.3,2.4-2.3,4-3s3.3-1,5.1-1c3.4,0,6.1,1.1,8.2,3.2c2,2.2,3,5.1,3,8.7v22
			h-8.9v-19.5c0-2.1-0.5-3.7-1.4-4.8c-0.9-1.1-2.2-1.6-4-1.6c-1.8,0-3.2,0.6-4.4,1.8c-1.2,1.2-1.7,2.8-1.7,4.8v19.3H364.8z'
        />
        <path
          className='st0'
          d='M408.6,320.4c-2.1-0.8-3.8-2.1-5.3-3.7c-1.4-1.6-2.5-3.4-3.3-5.5s-1.1-4.4-1.1-6.9c0-2.4,0.4-4.6,1.1-6.7
			c0.8-2.1,1.9-3.9,3.3-5.5c1.5-1.6,3.2-2.9,5.3-3.8c2-0.9,4.2-1.3,6.5-1.3c4.6,0,8.3,1.5,11.1,4.6c2.7,3.1,4.1,7.1,4.1,12.1v2.6
			h-23c0.3,2.5,1.2,4.5,2.6,6c1.5,1.4,3.3,2.2,5.5,2.2c1.8,0,3.3-0.4,4.5-1.3c1.2-0.8,2.1-2,2.6-3.6l7.5,2.7c-1.2,3-3.1,5.3-5.7,7
			c-2.6,1.7-5.6,2.5-9,2.5C412.9,321.6,410.6,321.2,408.6,320.4z M410.3,295.6c-1.3,1.1-2.2,2.6-2.7,4.6h13.8c0-1.9-0.6-3.3-1.8-4.5
			c-1.2-1.1-2.7-1.7-4.7-1.7C413.2,294.1,411.6,294.6,410.3,295.6z'
        />
        <path
          className='st0'
          d='M438.3,319.9c-2.8-1.1-4.9-2.7-6.4-4.6l5.5-5.6c1.1,1.5,2.6,2.7,4.5,3.7c1.8,0.9,3.7,1.4,5.6,1.4
			c1.7,0,3.1-0.3,4.1-0.9c1-0.6,1.5-1.4,1.5-2.5c0-0.8-0.2-1.4-0.7-1.8c-0.5-0.4-1.3-0.8-2.5-1.1c-0.3-0.1-0.7-0.2-1.1-0.3
			c-0.4-0.1-1.6-0.3-3.6-0.7c-2.2-0.4-3.8-0.8-4.9-1.2c-1.1-0.4-2.1-0.9-2.9-1.4c-1.2-0.8-2.1-1.7-2.7-2.9c-0.6-1.2-0.9-2.5-0.9-4.2
			c0-3.2,1.3-5.8,3.8-7.8c2.5-2,5.8-3,9.8-3c2.8,0,5.5,0.5,8,1.6s4.4,2.5,5.8,4.2l-5.1,5.6c-1.1-1.4-2.4-2.5-4-3.3s-3.2-1.1-4.9-1.1
			c-1.4,0-2.5,0.3-3.4,0.8c-0.8,0.5-1.3,1.3-1.3,2.2c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.3,0.1,0.7,0.2,1.2,0.3
			c0.4,0.1,1.3,0.3,2.7,0.5c2.6,0.5,4.4,1,5.6,1.4c1.1,0.4,2.1,0.8,3,1.3c1.4,0.8,2.4,1.8,3.1,3s1,2.7,1,4.4c0,3.3-1.4,6.1-4.1,8.1
			c-2.7,2.1-6.2,3.1-10.4,3.1C444.2,321.6,441.1,321.1,438.3,319.9z'
        />
        <path
          className='st0'
          d='M469.8,319.9c-2.8-1.1-4.9-2.7-6.4-4.6l5.5-5.6c1.1,1.5,2.6,2.7,4.5,3.7c1.8,0.9,3.7,1.4,5.6,1.4
			c1.7,0,3.1-0.3,4.1-0.9c1-0.6,1.5-1.4,1.5-2.5c0-0.8-0.2-1.4-0.7-1.8c-0.5-0.4-1.3-0.8-2.5-1.1c-0.3-0.1-0.7-0.2-1.1-0.3
			c-0.4-0.1-1.6-0.3-3.6-0.7c-2.2-0.4-3.8-0.8-4.9-1.2c-1.1-0.4-2.1-0.9-2.9-1.4c-1.2-0.8-2.1-1.7-2.7-2.9c-0.6-1.2-0.9-2.5-0.9-4.2
			c0-3.2,1.3-5.8,3.8-7.8c2.5-2,5.8-3,9.8-3c2.8,0,5.5,0.5,8,1.6s4.4,2.5,5.8,4.2l-5.1,5.6c-1.1-1.4-2.4-2.5-4-3.3s-3.2-1.1-4.9-1.1
			c-1.4,0-2.5,0.3-3.4,0.8c-0.8,0.5-1.3,1.3-1.3,2.2c0,0.6,0.2,1.1,0.6,1.5c0.4,0.4,1,0.7,1.9,1c0.3,0.1,0.7,0.2,1.2,0.3
			c0.4,0.1,1.3,0.3,2.7,0.5c2.6,0.5,4.4,1,5.6,1.4c1.1,0.4,2.1,0.8,3,1.3c1.4,0.8,2.4,1.8,3.1,3s1,2.7,1,4.4c0,3.3-1.4,6.1-4.1,8.1
			c-2.7,2.1-6.2,3.1-10.4,3.1C475.6,321.6,472.6,321.1,469.8,319.9z'
        />
        <path className='st0' d='M520.3,275.4v45.5H511v-45.5H520.3z' />
        <path
          className='st0'
          d='M536.5,297c-1.4,1.8-2.1,4.2-2.1,7.2c0,3.1,0.7,5.5,2.1,7.3c1.4,1.8,3.3,2.6,5.7,2.6c1.7,0,3.1-0.5,4.3-1.6
			c1.2-1,2-2.5,2.4-4.4l7.7,3.4c-0.8,3-2.6,5.4-5.2,7.3c-2.6,1.8-5.7,2.8-9.3,2.8c-2.4,0-4.6-0.4-6.7-1.3c-2.1-0.8-3.8-2.1-5.3-3.7
			c-1.5-1.6-2.6-3.4-3.4-5.5s-1.1-4.4-1.1-6.8s0.4-4.7,1.1-6.8s1.9-4,3.4-5.5c1.5-1.6,3.3-2.8,5.3-3.7c2.1-0.8,4.3-1.3,6.7-1.3
			c3.6,0,6.6,0.9,9.2,2.7s4.3,4.2,5.2,7.1l-7.5,3.6c-0.5-1.9-1.3-3.4-2.4-4.4c-1.2-1-2.6-1.6-4.3-1.6
			C539.8,294.4,537.9,295.3,536.5,297z'
        />
        <path
          className='st0'
          d='M568.3,320.4c-2.1-0.8-3.8-2.1-5.3-3.7c-1.4-1.6-2.5-3.4-3.3-5.5s-1.1-4.4-1.1-6.9c0-2.4,0.4-4.6,1.1-6.7
			c0.8-2.1,1.9-3.9,3.3-5.5c1.5-1.6,3.2-2.9,5.3-3.8c2-0.9,4.2-1.3,6.5-1.3c4.6,0,8.3,1.5,11.1,4.6c2.7,3.1,4.1,7.1,4.1,12.1v2.6
			h-23c0.3,2.5,1.2,4.5,2.6,6c1.5,1.4,3.3,2.2,5.5,2.2c1.8,0,3.3-0.4,4.5-1.3c1.2-0.8,2.1-2,2.6-3.6l7.5,2.7c-1.2,3-3.1,5.3-5.7,7
			c-2.6,1.7-5.6,2.5-9,2.5C572.7,321.6,570.4,321.2,568.3,320.4z M570.1,295.6c-1.3,1.1-2.2,2.6-2.7,4.6h13.8c0-1.9-0.6-3.3-1.8-4.5
			c-1.2-1.1-2.7-1.7-4.7-1.7C572.9,294.1,571.4,294.6,570.1,295.6z'
        />
        <path className='st0' d='M603.8,275.4v45.5H595v-45.5H603.8z' />
        <path
          className='st0'
          d='M625.6,320.6c-1.7,0.6-3.6,1-5.7,1c-3.3,0-6.1-0.9-8.2-2.7c-2.1-1.8-3.2-4.2-3.2-7.1c0-2.9,1-5.2,2.9-6.9
			s5-3,9.1-3.7l8.3-1.6v-0.5c0-1.6-0.4-2.7-1.3-3.5c-0.8-0.8-2.1-1.1-3.9-1.1c-1.6,0-2.9,0.4-3.8,1.1c-0.9,0.7-1.6,1.8-2,3.4
			l-8.4-1.6c0.8-3.1,2.6-5.6,5.2-7.4c2.6-1.9,5.7-2.8,9.4-2.8c4.4,0,7.7,1,10,3c2.3,2,3.5,4.9,3.5,8.6v13.6c0,0.9,0.2,1.5,0.6,1.8
			c0.4,0.3,1.1,0.4,2.1,0.3v6.7c-2.7,0.4-5,0.3-6.8-0.2c-1.8-0.5-3-1.5-3.8-2.9C628.7,319,627.3,319.9,625.6,320.6z M626.8,313.2
			c1.4-1.1,2.1-2.4,2.1-4.1v-3.4l-6.5,1.3c-1.8,0.3-3.1,0.8-3.9,1.5s-1.2,1.6-1.2,2.7c0,1.1,0.4,2,1.2,2.7c0.8,0.6,1.8,1,3.2,1
			C623.7,314.8,625.4,314.3,626.8,313.2z'
        />
        <path
          className='st0'
          d='M645,320.9v-33.3h8.9v3.4c1.1-1.3,2.4-2.3,4-3s3.3-1,5.1-1c3.4,0,6.1,1.1,8.2,3.2c2,2.2,3,5.1,3,8.7v22h-8.9
			v-19.5c0-2.1-0.5-3.7-1.4-4.8c-0.9-1.1-2.2-1.6-4-1.6c-1.8,0-3.2,0.6-4.4,1.8c-1.2,1.2-1.7,2.8-1.7,4.8v19.3H645z'
        />
        <path
          className='st0'
          d='M687.3,320.2c-1.9-0.9-3.4-2.3-4.8-4c-1.2-1.6-2.1-3.4-2.7-5.4c-0.6-2-0.9-4.2-0.9-6.6s0.3-4.5,0.9-6.6
			c0.6-2,1.5-3.8,2.7-5.4c1.3-1.8,2.9-3.1,4.8-4c1.9-0.9,3.9-1.4,6.1-1.4c1.9,0,3.7,0.3,5.3,1s2.9,1.7,4,3v-15.6h8.9v45.5h-8.9v-3.4
			c-1.1,1.3-2.4,2.3-4,3c-1.6,0.7-3.4,1.1-5.3,1.1C691.2,321.6,689.2,321.2,687.3,320.2z M703,303.4c0-2.7-0.7-4.9-2-6.4
			s-3.1-2.4-5.4-2.4c-2.4,0-4.3,0.9-5.6,2.6s-2,4.1-2,7.1c0,3,0.7,5.4,2,7.2s3.2,2.6,5.6,2.6c2.2,0,4-0.8,5.4-2.4s2-3.7,2-6.4V303.4
			z'
        />
      </g>
    </g>
  </svg>
)
